import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import CommonPopup from 'components/common/CommonPopup';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './ShareSettings.scss';

const ShareSettings = ({ me, patchUser }) => {
  const onShareProfileChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('share_profile', checked);
    patchUser(form);
  };

  const onShareLinksChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('share_links', checked);
    patchUser(form);
  };

  const { t } = useTranslation();

  // me.subscription.ff_sharing
  // You can change share settings on the <strong>PRO</strong> plan. Check it

  return (
    <DashboardFormSection
      className="share-settings__component"
      proLabel
      header={t("SHARE SETTINGS")}
    >
      {/* Profile Sharing */}
      <div className="setting-section">
        <div className="label-wrapper">
          <div className="label-text">{t("Turn ON/OFF Profile Sharing")}</div>
          <CommonPopup
            key="share-settings-popup-profile-key"
            questionIcon
            type="info"
            className="share-settings-popup"
          >
            <div className="popup-wrapper profile">
              <div className="text">
                {t("You can allow or hide social sharing on your profile")}
              </div>
              <div className="images-block off">
                <div className="image-wrapper">
                  <div className="label">{t("Turn OFF")}</div>
                  <div className="image" />
                </div>
              </div>
              <div className="images-block on">
                <div className="image-wrapper">
                  <div className="label">{t("Turn ON")}</div>
                  <div className="image" />
                </div>
              </div>
            </div>
          </CommonPopup>
        </div>

        <ProFeaturePlaceholder
          className="share-settings-pro-placeholder"
          noKeyIcon
          proLabel
          locked={
            me &&
            me.subscription &&
            !me.subscription.ff_sharing
          }
          placeholderContent={
            <div>
              {t("You can change share settings on the PRO plan.")}
            </div>
          }
        >
          <div className="checkbox-wrapper">
            <div className="option">{t("OFF")}</div>
            <Checkbox
              key="share-profile-settings-checkbox-key"
              toggle
              checked={me.share_profile}
              onChange={onShareProfileChange}
              disabled={
                me &&
                me.subscription &&
                !me.subscription.ff_sharing
              }
            />
            <div className="option">{t("ON")}</div>
          </div>
        </ProFeaturePlaceholder>

      </div>

      {/* Links Sharing */}
      <div className="setting-section">
        <div className="label-wrapper">
          <div className="label-text">{t("Turn ON/OFF Links Sharing")}</div>
          <CommonPopup
            key="share-settings-popup-links-key"
            questionIcon
            type="info"
            className="share-settings-popup links"
          >
            <div className="popup-wrapper links">
              <div className="text">
                {t("You can allow or hide social sharing on your links")}
              </div>
              <div className="images-block off">
                <div className="image-wrapper">
                  <div className="label">{t("Turn OFF")}</div>
                  <div className="image" />
                </div>
              </div>
              <div className="images-block on">
                <div className="image-wrapper">
                  <div className="label">{t("Turn ON")}</div>
                  <div className="image" />
                </div>
              </div>
            </div>
          </CommonPopup>
        </div>

        <ProFeaturePlaceholder
          className="share-settings-pro-placeholder"
          noKeyIcon
          proLabel
          locked={
            me &&
            me.subscription &&
            !me.subscription.ff_sharing
          }
          placeholderContent={
            <div>
              {t("You can change share settings on the PRO plan. Check it")}
            </div>
          }
        >
          <div className="checkbox-wrapper">
            <div className="option">{t("OFF")}</div>
            <Checkbox
              key="share-links-settings-checkbox-key"
              toggle
              checked={me.share_links}
              onChange={onShareLinksChange}
              disabled={
                me &&
                me.subscription &&
                !me.subscription.ff_sharing
              }
            />
            <div className="option">{t("ON")}</div>
          </div>
        </ProFeaturePlaceholder>

      </div>
    </DashboardFormSection>
  );
};

ShareSettings.propTypes = {
  patchUser: PropTypes.func.isRequired,
  me: PropTypes.object,
};
ShareSettings.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(ShareSettings);
